import React from "react";


// import { Link } from "react-router-dom";


function HeroSection(props)  {
  return (
    <>
      <section className="hero-section">
        <div className="container ">
          
      <div className="text-center mb-4">
          <div className="hero-title text-gradient">
             {props.title}
          </div>
          <div className="hero-subTitle">
            {props.subtitle}
            
          </div>
          </div>
          </div>
        </section>


       
    </>
  );
};



export default HeroSection;
